import { enumConvert } from '../../helpers/enumConvert';
import { GoalBase } from '../Base/Goal';

export const Goal = enumConvert(GoalBase);
